import { render } from "./Works.vue?vue&type=template&id=1a174d29&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=1a174d29&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a174d29"]])

export default __exports__